import { apiText, useApiState } from '../api/state';

/** The worker API state, as every ".api-state" element shows it. */
export function ApiStateText() {
  const s = useApiState();
  return <span className="api-state" data-mode={s.mode}>{apiText(s)}</span>;
}
